"use client";

import { useLanguage } from "@/lib/i18n/LanguageContext";
import { CheckCircle } from "lucide-react";

export default function TrustBadges() {
  const { t } = useLanguage();

  return (
    <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 mt-6 sm:mt-8">
      {/* MOZ Accredited Badge */}
      <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-gray-100">
        <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />
        <span className="text-sm font-medium text-gray-800">
          {t('home.trust.mozAccredited')}
        </span>
      </div>

      {/* Doctors Count Badge */}
      <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-gray-100">
        <span className="text-sm font-bold text-blue-600">94 000+</span>
        <span className="text-sm text-gray-600">
          {t('home.trust.doctorsTrust')}
        </span>
      </div>

      {/* Events Held Badge */}
      <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-gray-100">
        <span className="text-sm font-bold text-blue-600">900+</span>
        <span className="text-sm text-gray-600">
          {t('home.trust.eventsHeld')}
        </span>
      </div>
    </div>
  );
}
